import React from 'react';

interface LoadingDotsProps {
  text?: string;
  className?: string;
}

export const LoadingDots: React.FC<LoadingDotsProps> = ({ text, className = '' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex space-x-1 items-center h-4">
        <div className="w-1.5 h-1.5 bg-gray-600 dark:bg-gray-400 rounded-full animate-[bounce_1s_infinite_0ms]"></div>
        <div className="w-1.5 h-1.5 bg-gray-600 dark:bg-gray-400 rounded-full animate-[bounce_1s_infinite_200ms]"></div>
        <div className="w-1.5 h-1.5 bg-gray-600 dark:bg-gray-400 rounded-full animate-[bounce_1s_infinite_400ms]"></div>
      </div>
      {text && (
        <span className="text-sm text-gray-600 dark:text-gray-300">{text}</span>
      )}
    </div>
  );
};